export default "__VITE_ASSET__B0OVzH3g__"